import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { ConfirmEmail } from "../../api/services/Auth.api";
import { useEffect, useState } from "react";
import EmailConfirmationPage from "../../components/EmailConfirmation/EmailConfirmationPage";
import { useTranslation } from "react-i18next";

const EmailConfirmationContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [activateSuccess, setActivateSuccess] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("userId");
  const token = queryParams.get("token");

  useEffect(() => {
    if (userId && token) {
      const body = {
        UserId: userId,
        Token: token,
      };
      ConfirmEmail(body)
        .then((resp) => {
          const data = resp.data.message;
          if (data === "SuccessfullyConfirmedEmail") {
            setActivateSuccess(true);
            enqueueSnackbar(t("successfullyActivatedAccount"), {
              variant: "success",
            });
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
      navigate("/");
    }
  }, [enqueueSnackbar, navigate, t, token, userId]);

  return (
    <EmailConfirmationPage
      loading={loading}
      activateSuccess={activateSuccess}
    />
  );
};

export default EmailConfirmationContainer;
